import { NavigationInstruction, Router, RedirectToRoute } from "aurelia-router";
import { autoinject } from "aurelia-dependency-injection";
import { UserClaimsService } from "../../services/authentication/user-claims.service";
import { GenesisRouterConstants } from "../../configuration/router.constants";
import { Next } from "aurelia-router";
import * as Enumerable from "linq";
import { UserClientService } from "../../services/authentication/user-client.service";

@autoinject
export class ClaimsStep {

    constructor(private userClaimsService: UserClaimsService, private userClientService: UserClientService, private router: Router) {
    }

    run(navigationInstruction: NavigationInstruction, next: Next): Promise<any> {
        const requiresAuthAndIsNotAuthenticated = navigationInstruction.config && navigationInstruction.config.auth && !this.userClientService.currentUser;
        const requiresClaimsAndNotHaveClaims = navigationInstruction.config && this.getClaims(navigationInstruction.config) && !this.userClaimsService.hasPermissions(this.getClaims(navigationInstruction.config), navigationInstruction.config.claimsRequireType);

        if (requiresAuthAndIsNotAuthenticated || requiresClaimsAndNotHaveClaims) {
            if (this.router.routes) {
                const route = Enumerable.from(this.router.routes).firstOrDefault(x => this.getClaims(x) && this.userClaimsService.hasPermissions(this.getClaims(x),x.claimsRequireType));
                if (route) {
                    return next.cancel(new RedirectToRoute(route.name));
                }
            } else {
                return next.cancel(new RedirectToRoute(GenesisRouterConstants.RouteNames.Login));
            }
        }

        return next();
    }

    public getClaims(nav) {
        return nav.claimsRequired ? nav.claimsRequired : (nav.claims ? nav.claims : null);
    }
}

